/**
 * Badge del estado de una búsqueda del intake (spec §2): tono del catálogo
 * `enum-badge` + etiqueta traducida.
 */
import { useTranslation } from 'react-i18next';
import { EnumBadge } from '@/components/ui/enum-badge';
import { TA_INTAKE_STATUS_TONE } from '@/../../shared/ta-intake';
import type { TaIntakeStatus } from '@/../../shared/types/ta-intake';

export function TaIntakeStatusBadge({ status, className }: { status: TaIntakeStatus; className?: string }) {
  const { t } = useTranslation();
  return <EnumBadge value={status} tone={TA_INTAKE_STATUS_TONE[status]} label={t(`talent_acquisition.intake.status.${status}`)} className={className} />;
}
